import { HasuraFilterInputModel } from '../../../models/HasuraFilterInputModel';
import { HasuraOrderByInputModel } from '../../../models/HasuraOrderByInputModel';

interface BoutiqueDailyHours {
  iso: number;
  openAt: string;
  closeAt: string;
  isClosed: boolean;
}

interface GeocodedCoordinate {
  latitude: number;
  longitude: number;
}

interface Address {
  address: string;
  city: string;
  countryCode?: string;
  line1: string;
  line2: string;
  postalCode: string;
  region: string;
  sublocality: string;
}

export enum BoutiqueType {
  Boutique = 'AP_BOUTIQUE',
  House = 'AP_HOUSE',
}

export enum BoutiqueOwner {
  JointVenture = 'JOINT_VENTURE',
  Internal = 'INTERNAL',
}

export default interface MasterDataBoutique {
  _id: string;
  address: Address;
  bookingEnabled: boolean;
  boutiqueId?: string;
  email: string;
  gpsCoordinates: GeocodedCoordinate;
  hours?: BoutiqueDailyHours[];
  isVisible: boolean;
  mainPhone: string;
  masterclasses: string[];
  name: string;
  owner: BoutiqueOwner;
  photoUrl: string;
  serviceCenter: boolean;
  timezone: string;
  type: BoutiqueType;
}

// Hasura GraphQL resolvers

export interface MasterDataBoutiqueFilterInput extends HasuraFilterInputModel<MasterDataBoutique> {
  address?: HasuraFilterInputModel<MasterDataBoutique['address']>;
  gpsCoordinates?: HasuraFilterInputModel<MasterDataBoutique['gpsCoordinates']>;
  hours?: HasuraFilterInputModel<NonNullable<MasterDataBoutique['hours']>>;
}

export interface MasterDataBoutiqueOrderByInput extends HasuraOrderByInputModel<MasterDataBoutique> {
  address?: HasuraOrderByInputModel<MasterDataBoutique['address']>;
  gpsCoordinates?: HasuraOrderByInputModel<MasterDataBoutique['gpsCoordinates']>;
  hours?: HasuraOrderByInputModel<NonNullable<MasterDataBoutique['hours']>>;
}
